import angular from 'angular';

import BackdropControls from './bd-controls/bd-controls.component';

export default angular.module('autoboard.backdropTitle', [BackdropControls])
  .directive('bdTitle', function ($timeout) {
    'ngInject';

    return {
      // controller: BackdropRailController,
      restrict: 'E',
      transclude: true,
      // scope: {
      //   title: '@',
      //   subtitle: '@'
      // },
      scope: true,
      templateUrl: require('./bd-title.template.html')
    }
  })
  .name;